document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("filter.v.availability")) return;

  const filterModal = document.querySelector(".collection-modal");
  if (!filterModal) return;

  const path = window.location.pathname;
  const handleMatch = path.match(/\/collections\/([^\/]+)/);
  if (!handleMatch) return;

  const collectionHandle = handleMatch[1];

  fetch(`/collections/${collectionHandle}/products.json?limit=250`)
    .then(res => res.json())
    .then(data => {
      const visibleTags = new Set();

      data.products.forEach(product => {
        // Detect if at least one variant is available
        const isAvailable = product.variants.some(v => v.available);
        if (!isAvailable) return;

        product.tags.forEach(tag => {
          const clean = tag.trim().toLowerCase();
          visibleTags.add(clean);
        });
      });

      const filterItems = filterModal.querySelectorAll(".filter-item a[data-tag]");

      filterItems.forEach(item => {
        const tag = item.getAttribute("data-tag").trim().toLowerCase();
        if (!visibleTags.has(tag)) {
          item.closest(".filter-item").style.display = "none";
        }
      });
    })
    .catch(err => {
      console.warn("Error loading JSON:", err);
    });
});
